import { builder } from '$internal/utils/seo';
import { contentsMap } from '$internal/routes/content';
import { dev } from '$app/environment';
import { error } from '@sveltejs/kit';
import type { Metadata } from '$internal/routes/types.js';

export const prerender = true;

export async function load({ url, params }) {
	const glob = contentsMap.get(params.any);
	if (!glob) throw error(404);

	handleIssues(url, validate(glob.metadata));

	return {
		content: glob.default,
		metadata: glob.metadata,
		seo: builder(
			url,
			glob.metadata.seo || { title: glob.metadata.title, description: glob.metadata.description }
		)
	};
}

function validate(metadata: Metadata): string[] {
	const issues: string[] = [];
	if (!metadata.title) issues.push('Missing title');
	if (!metadata.description) issues.push('Missing description');
	return issues;
}

function handleIssues(url: URL, issues: string[]) {
	if (!issues.length) return;
	const message = `Invalid metadata in ${url.toString()}`;
	console.error(message);
	console.error('\t' + issues.map((i) => `- ${i}`).join('\n'));
	if (!dev) throw error(500, message);
}
